exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sf-sidebar__eu-warranty .eu-warranty-label{display:block;margin-top:16px}.sf-sidebar__eu-warranty .eu-warranty-label img{display:block;width:100%;height:auto;background:#fff}.sf-sidebar__eu-warranty .eu-warranty-label-url{margin:12px 0 0;word-break:break-all}.sf-sidebar__eu-warranty .eu-warranty-label-url a{text-decoration:underline}\n", ""]);

// exports
